import Fortress from '@/services/fortress/Fortress';
import {tokenSerializer} from '@/utils/token';

export default async function createAuthHeaders({
  brandId,
  accept = 'application/json',
  contentType = 'application/json',
}: {
  brandId?: string;
  accept?: string;
  contentType?: string;
}) {
  const authHeaders = await tokenSerializer();
  const ltxAuthToken = (await Fortress.getAccessToken()) || '';
  return {
    'Content-Type': contentType,
    'Accept': accept,
    'x-lightricks-auth-token': ltxAuthToken,
    ...(brandId ? {'x-brand-id': brandId} : {}),
    ...(authHeaders || {}),
  } as Record<string, string>;
}
